import React, { Component } from 'react'
import { Element, scroller } from 'react-scroll'

// Styles
import './index.scss'

// Constants
import { SOLUTIONS } from './constants'

class Solutions extends Component {

  componentDidMount = () => {
    this.scrollToElement()
  }

  scrollToElement = () => {
    const { match, history } = this.props

    const isSectionPresent = SOLUTIONS.find(item => item.scrollId === match.params.section)

    if (isSectionPresent) {
      scroller.scrollTo(`${match.params.section}`, {
        duration: 1500,
        delay: 0,
        smooth: 'easeInOutQuart',
        offset: -50,
      })
    } else {
      history.push('/solutions')
    }

  }

  render = () => {
    return (
      <div className="solutions-parent">
        <div className="page-banner bg-page-banner vh-center">
          <div className="banner-content">
            <h2>Solutions</h2>
          </div>
        </div>

        {
          SOLUTIONS.map((item, i) => {
            return (
              <div className="f-w" key={item.bg + i}>
                <div className="container content-image flex vh-center xlg-col-flex"  name={item.scrollId}>
                {
                  item.order === 'flip' ?

                    <React.Fragment>
                      <div className="content width-50">
                        <h2>{item.head}</h2>
                        {item.content}
                      </div>

                      <div className="width-50 lg-order-2">
                        <div className={`image ${item.bg}`}></div>
                      </div>

                    </React.Fragment>

                    :

                    <React.Fragment>
                      <div className="width-50 lg-order-2">
                        <div className={`image ${item.bg}`}></div>
                      </div>

                      <div className="content width-50">
                        <h2>{item.head}</h2>
                        {item.content}
                      </div>
                    </React.Fragment>

                }

              </div>
              </div>
            )
          })
        }
      </div>
    )
  }
}

export default Solutions